// RegisterForm.jsx
import React, { useState } from 'react';
import { userService } from '../../services/api';
import '../../styles/RegisterForm.css';

export default function RegisterForm() {
  const [formData, setFormData] = useState({
    username: '',
    lastname: '',
    firstname: '',
    email: '',
    password: '',
    confirmPassword: '',
  });

  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleChange = (e) => {
    setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    if (formData.password !== formData.confirmPassword) {
      setError("Les mots de passe ne correspondent pas.");
      return;
    }

    try {
      const response = await userService.register({
        username: formData.username,
        last_name: formData.lastname,
        first_name: formData.firstname,
        email: formData.email,
        password: formData.password,
      });

      if (response.status === 201 || response.status === 200) {
        setSuccess("Inscription réussie ! Vous pouvez maintenant vous connecter.");
        setFormData({
          username: '',
          lastname: '',
          firstname: '',
          email: '',
          password: '',
          confirmPassword: '',
        });
      } else {
        setError(response.data?.message || 'Erreur lors de l\'inscription.');
      }
    } catch (err) {
      if (err.response && err.response.data) {
        setError(err.response.data.message || 'Erreur lors de l\'inscription.');
      } else {
        setError('Erreur réseau ou serveur.');
      }
      console.error(err);
    }
  };

  return (
    <div className="page-wrapper">
      <header className="main-header">
        {/* Header content commented out as in original */}
      </header>

      <main className="form-container">
        <div className="form-header">
          <h2>Créer un compte</h2>
          <p>Rejoignez-nous et accédez à toutes les fonctionnalités</p>
        </div>
        
        <form onSubmit={handleSubmit} noValidate className="registration-form">
          {/* Nom et Prénom côte à côte */}
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="lastname">Nom</label>
              <input 
                type="text" 
                id="lastname"
                name="lastname" 
                placeholder="Votre nom" 
                value={formData.lastname} 
                onChange={handleChange} 
                required 
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="firstname">Prénom</label>
              <input 
                type="text" 
                id="firstname"
                name="firstname" 
                placeholder="Votre prénom" 
                value={formData.firstname} 
                onChange={handleChange} 
                required 
              />
            </div>
          </div>

          {/* Username et Email côte à côte */}
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="username">Nom d'utilisateur</label>
              <input 
                type="text" 
                id="username"
                name="username" 
                placeholder="Nom d'utilisateur" 
                value={formData.username} 
                onChange={handleChange} 
                required 
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input 
                type="email" 
                id="email"
                name="email" 
                placeholder="votre@email.com" 
                value={formData.email} 
                onChange={handleChange} 
                required 
              />
            </div>
          </div>

          {/* Mot de passe et Confirmation côte à côte */}
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="password">Mot de passe</label>
              <input 
                type="password" 
                id="password"
                name="password" 
                placeholder="••••••••" 
                value={formData.password} 
                onChange={handleChange} 
                required 
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="confirmPassword">Confirmer le mot de passe</label>
              <input 
                type="password" 
                id="confirmPassword"
                name="confirmPassword" 
                placeholder="••••••••" 
                value={formData.confirmPassword} 
                onChange={handleChange} 
                required 
              />
            </div>
          </div>

          {/* Messages d'erreur et de succès */}
          {error && <div className="message error-msg">{error}</div>}
          {success && <div className="message success-msg">{success}</div>}

          {/* Bouton de soumission */}
          <button type="submit" className="btn submit-btn">
            <span>S'INSCRIRE</span>
            <div className="btn-overlay"></div>
          </button>
          
          <div className="form-footer">
            <p>Déjà un compte ? <a href="/login">Se connecter</a></p>
          </div>
        </form>
      </main>
    </div>
  );
}